import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
export default {
    namespaced: true,
    state: {
        endpoint: "users",
        object: "user",
        header: [
            { text: "Activity", value: "id" },
            { text: "Name", value: "name" },
            { text: "Location", value: "location" },
            { text: "Price", value: "price" },
            { text: "Actions", value: "actions", sortable: false },
        ],
        list: [],
        list_videos: [],
        list_pictures:[],
        page: 1,
        total: 0,
        total_videos:0,
        total_pictures:0,
        options: {
            itemsPerPage: 10,
            search: ""
        },
    },
    mutations: {
        request(state) {
            state.status = "loading";
        },
        success(state, data) {
            state.status = "success";
            if (data && data["list"]) {
                state.list = data["list"];
            }
            if (data && data["list_videos"]) {
                state.list_videos = data["list_videos"];
            }
            if (data && data["list_pictures"]) {
                state.list_pictures = data["list_pictures"];
            }
            if (data && data["total_videos"]) {
                state.total_videos = data["total_videos"];
            }
            if (data && data["total_videos"]) {
                state.total_videos = data["total_videos"];
            }
            if (data && data["total"]) {
                state.total = data["total"];
            }
        },
        error(state) {
            state.status = "error";
        },
        options(state, data) {
            state.options = data;
        }
    },
    actions: {
        getListAll({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                axios
                    .get(config.api_url + "get_users", {
                        params: filter
                    })
                    .then(response => {
                        commit("success", {
                            list: response.data,
                            total: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        addPicturesUser({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                const formData = jsonToFormData(filter, {
                    arrayIndexes: true,
                    excludeNull: true,
                });
                axios
                    .post(config.api_url + "user/pictures", formData)
                    .then(response => {
                        commit("success", {
                            list_pictures: response.data,
                            total_pictures: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        getPicturesUser({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                axios
                    .get(config.api_url + "user/pictures", {
                        params: filter
                    })
                    .then(response => {
                        commit("success", {
                            list_pictures: response.data,
                            total_pictures: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        deletePicturesUser({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                axios
                    .delete(config.api_url + "user/pictures", {
                        params: filter
                    })
                    .then(response => {
                        commit("success", {
                            list_pictures: response.data,
                            total_pictures: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        postUser({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                const formData = jsonToFormData(filter, {
                    arrayIndexes: true,
                    excludeNull: true,
                });
                axios
                    .post(config.api_url + "user", formData)
                    .then(response => {
                        commit("success")
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        addVideosUser({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                const formData = jsonToFormData(filter, {
                    arrayIndexes: true,
                    excludeNull: true,
                });
                axios
                    .post(config.api_url + "user/videos", formData)
                    .then(response => {
                        commit("success", {
                            list_videos: response.data,
                            total_videos: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        getVideosUser({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                axios
                    .get(config.api_url + "user/videos", {
                        params: filter
                    })
                    .then(response => {
                        commit("success", {
                            list_videos: response.data,
                            total_videos: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        deleteVideosUser({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");
                let filter = {
                    ...options
                    /* search: ""*/
                };
                axios
                    .delete(config.api_url + "user/videos", {
                        params: filter
                    })
                    .then(response => {
                        commit("success", {
                            list_videos: response.data,
                            total_videos: parseInt(
                                response.headers["pagination-count"]
                            )
                        });
                        resolve(response.data);
                    })
                    .catch(err => {
                        commit("error");
                        reject(err);
                    });
            });
        },
    },
    getters: {
        status(state) {
            return state.status;
        }
    },
};
